import Loader from "components/Loader";
import Pagination from "components/Pagination";
import PlaceholderBlockProfile from "components/placeholder-blocks/PlaceholderBlockProfile";
import ProfilePredictionStatusTable from "components/profile/ProfilePredictionStatusTable";
import { useEffect, useState } from "react";
import { createAPI } from "services/api/api";

const ProfilePredictionStatus = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [offsetCount, setOffsetCount] = useState(0);
  const api = createAPI();

  useEffect(() => {
    setIsLoading(true);
    api.get(`/me/prediction_status/params?limit=20&offset=${offsetCount}`)
      .then((response) => {
        setItems(response.data.data)
        setPaginationData(response.data.pagination_metadata)
      })
      .catch((error) => {
        console.log('failed to fetch profile prediction status ',error);
        setItems([])
      })
      .finally(() => setIsLoading(false));
  }, [offsetCount]);

  if (!items.length && isLoading === false) {
    return <main className="profile-content">
      <PlaceholderBlockProfile type='prediction' />
    </main>
  }

  return (
    <main className="profile-content">
      {
        isLoading ? <Loader />
        :
        <>
          <div className="cards-list">
            <header className="cards-list__header"><div className="cards-list__header-info">
              <h2 className="cards-list__title">
                Prediction Status
                <span>{paginationData.total_count}</span>
              </h2>
            </div>
            </header>
            <ProfilePredictionStatusTable items={items} />
          </div>

          <Pagination offsetCount={offsetCount} setOffsetCount={setOffsetCount} paginationData={paginationData} />
        </>
      }
    </main>
  )
}

export default ProfilePredictionStatus;
